module.exports = __webpack_public_path__ + "static/img/NSW-11.e02f9eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-11.jpg
// module id = L/AE
// module chunks = 0